import { AccountType, AccountTypeDisplayNames } from './constants';

export function getAccountTypeDisplayName(
  accountTypeString: string | null | undefined,
): string {
  if (!accountTypeString || accountTypeString.trim() === '') {
    return 'Unknown Account Type'; // Default value for invalid input
  }

  const accountTypeEnumValue = AccountType[accountTypeString as keyof typeof AccountType];
  return AccountTypeDisplayNames[accountTypeEnumValue] || accountTypeString;
}
export function getAccountTypeKey(value: number): string | undefined {
  return Object.keys(AccountType).find(
    (key) => AccountType[key as keyof typeof AccountType] === value,
  );
}
